<!--
 * @Author: your name
 * @Date: 2020-02-18 17:12:51
 * @LastEditTime: 2020-11-05 17:55:46
 * @LastEditors: OBKoro1
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Show.vue
 -->
<template>
  <div></div>
</template>
<script>
import wx from 'weixin-js-sdk'
import { Http } from "@/utils/http.js"
import api from "@/config/api.js"

export default {
  name: 'Share',
  created: function() {
     //return 
     let data = {}
     Http.post(api.getWechatJssdk, data).then(response => {
            wx.config({
                debug: false,
                appId: response.data.appId,
                timestamp: parseInt(response.data.timestamp),
                nonceStr: response.data.nonceStr,
                signature: response.data.signature,
                jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage'
                ],
                // 其它配置不变， openTagList配置可使用的开放标签, 
                openTagList: ['wx-open-launch-weapp']
            })
            wx.ready(function() {
                console.log('ready')
                wx.onMenuShareAppMessage({
                    title: '星空学院',
                    desc: '星空学院',
                    link: location.href,
                    imgUrl: 'http://wsl-cdn.medmeet.com.cn/1586483912116',
                    success: function () {
                       // alert("分享成功");
                    }
                });
                // 分享到朋友圈
                wx.onMenuShareTimeline({
                    title: '星空学院',
                    link: location.href,
                    imgUrl: 'http://wsl-cdn.medmeet.com.cn/1586483912116',
                    success: function () {
                        //alert("分享成功");
                    }
                });
            })
    }) 
    },
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Share.vue